import React from 'react';
import { Sparkles } from 'lucide-react';
import PromptChips from './PromptChips';
import type { Prompt } from '@/types/intelliHealthChat';

interface WelcomeStateProps {
  prompts: Prompt[];
  onSelectPrompt: (text: string) => void;
}

const WelcomeState: React.FC<WelcomeStateProps> = ({ prompts, onSelectPrompt }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-4">
      <Sparkles className="w-8 h-8 text-brand-teal mb-3" />
      <p className="text-sm text-slate-500 mb-4">
        Ask IntelliHealth a question
      </p>
      <PromptChips prompts={prompts} onSelect={onSelectPrompt} />
    </div>
  );
};

export default WelcomeState;
